import HomeService from "./HomeService";
import HomePortfolio from "./HomePortfolio";
import HomeTeam from "./HomeTeam";
import HomeTopServers from "./HomeTopServers";

const HomeDetailSection = () => {
  return (
    <div className="overflow-hidden">
      <HomeService />
      <HomePortfolio />
      <HomeTeam />
      <HomeTopServers />
    </div>
  );
};

export default HomeDetailSection;
